<template>
    <v-app id="login">
        <v-app-bar app color="white" light flat>
            <router-link :to="{name: 'home'}">
                <v-img alt="Logo" contain src="@/assets/ravenpod-text.png" transition="scale-transition" width="150"/>          
            </router-link>
        </v-app-bar>
        <amplify-authenticator :initial-auth-state="initAuthState">
            <amplify-sign-in
                slot="sign-in"
                username-alias="email">
            </amplify-sign-in>            
            <amplify-sign-up
                slot="sign-up"
                username-alias="email"
                :form-fields.prop="signUpFormFields">
            </amplify-sign-up>
        </amplify-authenticator>
        <Footer/>
    </v-app>
</template>

<script>

    import Footer from '@/components/Footer.vue'

    export default {
        components: {
            Footer
        },
        name: 'Auth',
        props: {
            initAuthState: {
                type: String,
                default: 'signup',
                required: false,
            },
            targetNamedRoute: {
                type: String,
                default: 'main',
                required: false
            },
            // amazonProductCode: {
            //     type: String,
            //     default: null,
            //     required: false,
            // },
            amazonCustomerId: {
                type: String,
                default: null,
                required: false
            }
        },        
        data() {
            return {
                signUpFormFields: [
                    {
                        type: 'name',
                        label: 'Name',
                        placeholder: 'Enter your name',
                        required: true,
                    },
                    {
                        type: 'email',
                        label: 'Email Address',
                        placeholder: 'Enter your email address',
                        required: true,
                    },
                    {
                        type: 'phone_number',
                        label: 'Mobile Phone number',
                        placeholder: 'Enter your mobile phone number',
                        required: true,
                    },
                    {
                        type: 'password',
                        label: 'Password',
                        placeholder: 'Enter your password',
                        required: true,
                    },
                    // {
                    //     type: 'custom:amazon_product_code',
                    //     required: false,
                    //     value: this.amazonProductCode,
                    //     inputProps: { style: {display: 'none'} }
                    // },
                    {
                        type: 'custom:amazon_customer_id',
                        required: false,
                        value: this.amazonCustomerId,
                        inputProps: { style: {display: 'none'} }
                    }                    
                ],           
            };
        },
        created() {
            console.log("Subscription data:", this.amazonCustomerId);
            console.log("Setting targetNamedRoute in Vuex as: ", this.targetNamedRoute)
            this.$store.dispatch('setTargetNamedRoute', this.targetNamedRoute)
        },
        computed: {
        },
        methods: {
        }
    };

</script>

<style>
</style>